import clx from 'classnames'
import React, { useState } from 'react'
import { fakeUsers } from '../../dummy/mock'

export const CreateGroup = () => {
    const [users, setUsers] = useState([...fakeUsers])
    return (
      <div className=''>
      <div
        class="bg-white dark:text-white dark:bg-zinc-800 p-3
        w-screen sm:w-[33rem] border dark:border-zinc-700 overflow-hidden h-auto rounded-md relative flex items-center justify-center z-[200]"
      >
        <div class="flex flex-col w-full">
          <h1 class="font-medium text-xl mb-3">Create a new chat group</h1>
          <input
            type="text"
            placeholder="Group name"
            name=""
            class="p-1 border bg-transparent dark:border-zinc-700 cursor-pointer text-gray-500 rounded-md h-12 w-full mb-2 p-3 outline-none"
          />


        <SelectTeam users={users} />
        

          <div class="flex mb-2">
          {users.reverse().map((item,key)=> key<5 && (
                <img
                key={'avatar-'+key}
                src={`/images/avatars/${item.avatar}.png`}
                title={item.name}
                class={clx(`h-12 w-12 border-4 dark:border-zinc-800 cursor-pointer 
                rounded-full border-zinc-100`, {'-ml-4': key!=0})}
                />
            ))}
            
          </div>
          <textarea 
            type="text"
            placeholder="Description"
            name=""
            class="p-1 border bg-transparent dark:border-zinc-700 cursor-pointer text-zinc-500 rounded-md h-32 w-full p-3 mb-2 outline-none"
          ></textarea>
          <div class="flex justify-between mt-2">
            <div></div>
            <div
              class="bg-blue-700 p-3 flex items-center justify-center text-white rounded-md cursor-pointer hover:bg-blue-600"
            >
              Start to conversation
            </div>
          </div>
        </div>
      </div>
    </div>
    )
}


export const SelectTeam = ({users}) => {
  const [show, setShow] = useState(false)
  const [selected, setSelected] = useState({})

  return (
    <React.Fragment>
       <div x-data="{status:false}" class="relative">
              <div
              onClick={()=>setShow(!show)}
                class="p-1 border bg-transparent dark:border-zinc-700 cursor-pointer text-gray-500 rounded-md h-12 w-full mb-2 outline-none flex items-center justify-between p-3"
              >
                <p class="text-zinc-400">Add new member</p>
                <i
                  x-show="!status"
                  data-feather="chevron-right"
                  class="h-8 stroke-zinc-400"
                ></i>
                <i
                  x-show="status"
                  data-feather="chevron-down"
                  class="h-8 stroke-zinc-400"
                ></i>
              </div>

              {show && (
                <div
                className={clx({'hidden':!show})}
                x-show="status"
                class="absolute border dark:border-zinc-700 top-14 left-0 z-10 bg-white rounded-lg shadow-lg w-60 dark:bg-zinc-700"
              >
                <ul
                  class="h-48 py-2 overflow-y-auto text-zinc-700 dark:text-zinc-200"
                  aria-labelledby="dropdownUsersButton"
                >
                 {users.map(item=> (
                  <li>
                    <a
                      href="#"
                      class="flex items-center px-4 py-2 hover:bg-zinc-100 dark:hover:bg-zinc-600 dark:hover:text-white"
                    >
                      <img
                        class="w-6 h-6 mr-2 rounded-full"
                        src={`/images/avatars/${item.avatar}.png`}
                        alt="Jese image"
                      />
                      {item.name}
                    </a>
                  </li>
               ))}
                </ul>
                <a
                  href="#"
                  class="flex items-center p-3 text-sm font-medium text-blue-600 border-t border-zinc-200 rounded-b-lg bg-zinc-50 dark:border-zinc-600 hover:bg-zinc-100 dark:bg-zinc-700 dark:hover:bg-zinc-600 dark:text-blue-500 hover:underline"
                >
                  <svg
                    class="w-4 h-4 mr-2"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 20 18"
                  >
                    <path
                      d="M6.5 9a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM8 10H5a5.006 5.006 0 0 0-5 5v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-2a5.006 5.006 0 0 0-5-5Zm11-3h-2V5a1 1 0 0 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 0 0 2 0V9h2a1 1 0 1 0 0-2Z"
                    />
                  </svg>
                  Add new user
                </a>
              </div>
              )}
            </div>
    </React.Fragment>
  )
}

